import React from 'react';
import './DocHQAddress.scss';
const DocHQAddress = () => (
	<React.Fragment>
		<div className='address-container'>
			<div className='row'>
				<div className='address-list'>
					<address>
						<h4>DocHQ</h4>
						<p>Wessex House</p>
						<p>Upper Market Street</p>
						<p>Eastleigh</p>
						<p>Hampshire</p>
						<p>SO50 9FD</p>
						<p>
							UK Tel: <a href='tel:+443300880645'>03300 880645</a>
						</p>
					</address>
					<p>Reg: 11589439 </p>
					<p>VAT Exempt</p>
				</div>
			</div>
		</div>
	</React.Fragment>
);

export default DocHQAddress;
